import { useRef } from "react";
import { Bold, Italic, Link as LinkIcon, Minus, Type } from "lucide-react";

export default function RichTextEditor({ value, onChange, placeholder, rows = 4, testid }) {
  const ref = useRef(null);

  const wrap = (before, after = before) => {
    const ta = ref.current;
    if (!ta) return;
    const start = ta.selectionStart;
    const end = ta.selectionEnd;
    const v = ta.value;
    const selected = v.slice(start, end) || "testo";
    const next = v.slice(0, start) + before + selected + after + v.slice(end);
    onChange(next);
    requestAnimationFrame(() => {
      ta.focus();
      ta.setSelectionRange(start + before.length, start + before.length + selected.length);
    });
  };

  const insertLink = () => {
    const ta = ref.current;
    if (!ta) return;
    const start = ta.selectionStart;
    const end = ta.selectionEnd;
    const v = ta.value;
    const selected = v.slice(start, end) || "testo";
    const url = window.prompt("URL del link:", "https://");
    if (!url) return;
    const next = v.slice(0, start) + `[${selected}](${url})` + v.slice(end);
    onChange(next);
  };

  const insertParagraph = () => {
    const ta = ref.current;
    if (!ta) return;
    const pos = ta.selectionStart;
    const v = ta.value;
    onChange(v.slice(0, pos) + "\n\n" + v.slice(pos));
  };

  const insertHr = () => {
    const ta = ref.current;
    if (!ta) return;
    const pos = ta.selectionStart;
    const v = ta.value;
    onChange(v.slice(0, pos) + "\n\n---\n\n" + v.slice(pos));
  };

  const Btn = ({ onClick, label, children }) => (
    <button
      type="button"
      onClick={onClick}
      title={label}
      aria-label={label}
      className="px-2 py-1.5 text-[0.7rem] font-sub uppercase tracking-[0.2em] border border-[color:var(--tr-border)] hover:bg-[color:var(--tr-ink)] hover:text-[color:var(--tr-bg)] transition-colors"
    >
      {children}
    </button>
  );

  return (
    <div data-testid={testid} className="space-y-2">
      <div className="flex flex-wrap items-center gap-1">
        <Btn onClick={() => wrap("**")} label="Grassetto">
          <Bold className="w-3.5 h-3.5" strokeWidth={1.75} />
        </Btn>
        <Btn onClick={() => wrap("*")} label="Corsivo">
          <Italic className="w-3.5 h-3.5" strokeWidth={1.5} />
        </Btn>
        <Btn onClick={insertLink} label="Link">
          <LinkIcon className="w-3.5 h-3.5" strokeWidth={1.5} />
        </Btn>
        <Btn onClick={insertParagraph} label="Nuovo paragrafo">
          <Type className="w-3.5 h-3.5" strokeWidth={1.5} />
        </Btn>
        <Btn onClick={insertHr} label="Separatore">
          <Minus className="w-3.5 h-3.5" strokeWidth={1.5} />
        </Btn>
        <span className="ml-2 label-eyebrow opacity-70 hidden sm:inline">
          **grassetto** · *corsivo* · [testo](url)
        </span>
      </div>
      <textarea
        ref={ref}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        className="tr-field !py-2 resize-y"
      />
    </div>
  );
}
